import {gsap, ScrollTrigger} from "../LibrariesImport";
import LoadScript from "../utils/LoadScript";
import {GlobalVariables} from "../GlobalVariables";

export default class ArchiveStore {
	static init() {
		this.storeContainer = document.querySelector('.store-list');
		this.mapContainer = document.querySelector('.store-map');

		if (!this.mapContainer) {
			return;
		}

		this.store = document.querySelectorAll(".card-store");

		LoadScript.load("https://maps.googleapis.com/maps/api/js?v=3.57&key=" + mcArgs.gmapApiKey + "&callback=Function.prototype&libraries=marker,places", () => {
			LoadScript.load(`${mcArgs.themeLink}/lib/markerclusterer-2.5.3.js`, () => {
				this.buildMap();
				this.buildSearchBox();
				this.buildMarkers();
				this.buildClusterer();
				this.zoomListener();
				this.pinMap();
			});
		});
	}

	static zoomListener() {
		setTimeout(() => {
			google.maps.event.addListener(this.map, 'center_changed', () => {
				this.debounceRefreshStoresList();
			});
			google.maps.event.addListener(this.map, 'zoom_changed', () => {
				this.debounceRefreshStoresList();
			});
		}, 500);
	}

	static debounceRefreshStoresList() {
		if (this.timer) {
			clearTimeout(this.timer);
		}
		this.timer = setTimeout(this.refreshStoresList.bind(this), 500);
	}

	static refreshStoresList() {
		const bounds = this.map.getBounds();
		this.markers.forEach(marker => {
			if (bounds.contains(marker.position)) {
				marker.storeElement.classList.remove("d-none");
			} else {
				marker.storeElement.classList.add("d-none");
			}
		});
		if (this.mapScrollTrigger){
			this.mapScrollTrigger.refresh();
		}

		setTimeout(()=>{
			GlobalVariables.smoother.scrollTo(".store-container", true);

		}, 100);
	}

	static buildMap() {
		this.markers = [];
		this.visibleMarkers = [];
		this.bounds = new google.maps.LatLngBounds();
		this.map = new google.maps.Map(this.mapContainer, {
			center: {
				lat: 46,
				lng: 4.6
			},
			zoom: 8,
			maxZoom: 16,
			streetViewControl: false,
			mapTypeControl: false,
			fullscreenControl: false,
			gestureHandling: "greedy",
			mapId: mcArgs.gmapMapId,
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_CENTER
			},
		});
		
		
	}
	
	

	static buildSearchBox() {
		// Create the search box and link it to the UI element.
		const input = document.querySelector("#pac-input");
		const searchBox = new google.maps.places.SearchBox(input);
		this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

		// Bias the SearchBox results towards current map's viewport.
		this.map.addListener("bounds_changed", () => {
			searchBox.setBounds(this.map.getBounds());
		});

		searchBox.addListener("places_changed", () => {
			const places = searchBox.getPlaces();

			if (places.length === 0) {
				return;
			}
			this.map.setZoom(15);
			this.map.panTo(places[0].geometry.location);
			GlobalVariables.smoother.scrollTo(".store-container", true);
		});
	}

	static buildMarkers() {
		this.store.forEach(store => {
			const icon = document.createElement('div');
			icon.classList.add("map-marker");
			icon.innerHTML = `
			<svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M2.91234 2.90227C6.65602 -0.827784 12.9031 -1.11279 16.9568 2.92605L16.9567 2.92615C21.2963 7.25024 20.7002 13.3086 17.0281 16.9673L9.96995 24L2.93621 16.9912C-1.06971 12.9996 -0.87891 6.67985 2.91234 2.90227ZM10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14Z" fill="#370028"/>
			</svg>
			`;
			const lat = store.dataset.latitude;
			const lng = store.dataset.longitude;
			if (!lat || !lng) {
				return;
			}
			let position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
			let marker = new google.maps.marker.AdvancedMarkerElement({
				id: store.dataset.index,
				position: position,
				map: this.map,
				content: icon
			});
			if (!store.classList.contains("d-none")) {
				this.visibleMarkers.push(marker);
				this.bounds.extend(position);
			}
			marker.storeElement = store;
			store.marker = marker;
			this.markers.push(marker);

			store.addEventListener("mouseenter", () => {
				store.marker.content.classList.add("active");
				store.marker.isStoreActive = true;
				this.clusterer.clusters.forEach(cluster => {
					let hasActiveMarker = false;
					cluster.markers.forEach(clusterMarker => {
						if (clusterMarker === store.marker) {
							hasActiveMarker = true;
						}
					});
					if (hasActiveMarker) {
						cluster.marker.content.classList.add("active");
					} else {
						cluster.marker.content.classList.remove("active");
					}
				});
			});

			store.addEventListener("mouseleave", () => {
				store.marker.content.classList.remove("active");
				store.marker.isStoreActive = false;
				this.clusterer.clusters.forEach(cluster => {
					cluster.marker.content.classList.remove("active");
				});
			});


			let infoWindow = new google.maps.InfoWindow();

			google.maps.event.addListener(marker, 'click', () => {

				if (this.activeInfoWindow) {
					this.activeInfoWindow.close();
				}

				const title = store.querySelector(".store-name").innerText;
				const address = store.querySelector(".store-address").innerHTML;
				const moreInfo = store.querySelector(".more-info").outerHTML;

				infoWindow.setContent(`
						<div class="map-tooltip-content">
							<div class="meta">
								<div class="title-level-2">${title}</div>	
								<div class="address">${address}</div>
								${moreInfo}	
							</div>						
						</div>
					`);
				infoWindow.open(this.map, marker);
				this.activeInfoWindow = infoWindow;
			});
		});
		this.map.fitBounds(this.bounds);
	}

	static buildClusterer() {
		this.clusterer = new markerClusterer.MarkerClusterer({
			markers: this.visibleMarkers,
			map: this.map,
			renderer: {
				render: ({count, position, markers}) => {
					let hasActiveMarker = false;
					markers.forEach(marker => {
						if (marker.isStoreActive) {
							hasActiveMarker = true;
						}
					});
					const customClusterPin = document.createElement('div');
					customClusterPin.classList.add("custom-cluster-pin");
					if (hasActiveMarker) {
						customClusterPin.classList.add("active");
					}
					customClusterPin.textContent = count;
					return new google.maps.marker.AdvancedMarkerElement({
						position,
						zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
						content: customClusterPin
					});
				}
			}
		});
	}

	static pinMap() {

		const matchMedia = gsap.matchMedia();
		matchMedia.add("(min-width: 1100px)", () => {
			this.mapScrollTrigger = ScrollTrigger.create({
				trigger: ".store-container",
				pin: ".store-map",
				start: "top 30px",
				end: "bottom bottom-=30px"
			});
		});
	}




}
